var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-mt-3"},[(_vm.$apollo.queries.release.loading)?_c('release-skeleton-loader'):(_vm.release)?_c('release-block',{attrs:{"release":_vm.release,"deployments":_vm.deployments}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }